export default __webpack_public_path__ + "static/media/coming-soon.b55571d8.png";